import React from 'react';
import './StylePageHeader.scss';
import {
  Button, styled, Switch,
  SwitchProps,
} from '@mui/material';
import { XlsxIcon } from '../../assets/TableIcons/XlsxIcon';
import { PrintIcon } from '../../assets/TableIcons';

interface SubHeading {
  subHeading?: string
  fieldId?: string;
  fieldName?: string;
  exFieldId?: string;
  exFieldName?: string;
  printIcon?: boolean;
  downloadExcel?: () => void;
  handlePrintClick?: () => void;
  buttonName?: string;
  handleButtonClick?: () => void;
  handleSwitchChange?: () => void;
  siteSwitch?: boolean;
  isChecked?: boolean;
}
export const IOSSwitch = styled((props: SwitchProps) => (
  <Switch focusVisibleClassName=".Mui-focusVisible" disableRipple {...props} />
))(({ theme }) => ({
  width: 42,
  height: 26,
  padding: 0,
  '& .MuiSwitch-switchBase': {
    padding: 0,
    margin: 2,
    transitionDuration: '300ms',
    '&.Mui-checked': {
      transform: 'translateX(16px)',
      color: '#fff',
      '& + .MuiSwitch-track': {
        backgroundColor: '#00a751',
        opacity: 1,
        border: 0,
        ...theme.applyStyles('dark', {
          backgroundColor: '#2ECA45',
        }),
      },
      '&.Mui-disabled + .MuiSwitch-track': {
        opacity: 0.5,
      },
    },
    '&.Mui-focusVisible .MuiSwitch-thumb': {
      color: '#33cf4d',
      border: '6px solid #fff',
    },
    '&.Mui-disabled .MuiSwitch-thumb': {
      color: theme.palette.grey[100],
      ...theme.applyStyles('dark', {
        color: theme.palette.grey[600],
      }),
    },
    '&.Mui-disabled + .MuiSwitch-track': {
      opacity: 0.7,
      ...theme.applyStyles('dark', {
        opacity: 0.3,
      }),
    },
  },
  '& .MuiSwitch-thumb': {
    boxSizing: 'border-box',
    width: 22,
    height: 22,
  },
  '& .MuiSwitch-track': {
    borderRadius: 26 / 2,
    backgroundColor: '#E9E9EA',
    opacity: 1,
    transition: theme.transitions.create(['background-color'], {
      duration: 500,
    }),
    ...theme.applyStyles('dark', {
      backgroundColor: '#39393D',
    }),
  },
}));

export default function ComponentPageHeader({
  subHeading, fieldId, fieldName, downloadExcel, printIcon, handlePrintClick, buttonName, handleButtonClick,
  exFieldId, exFieldName, siteSwitch = false, handleSwitchChange, isChecked,
}: SubHeading) {
  return (
    <div className="sub_header_container mob_sub_header_container">
      <div className="sub_heading">{subHeading}</div>
      <div className="print_container">
        {exFieldId && (
          <>
            <span className="customerID">
              {exFieldName}
              {' '}
              :
            </span>
            <div className="job_input_div">
              {/* <input disabled value={exFieldId} className="job_input_style" /> */}
              <div className="job_input_style">{exFieldId}</div>
            </div>
          </>
        )}
        {fieldId && (
          <>
            <span className="customerID">
              {fieldName}
              {' '}
              :
            </span>
            <div className="job_input_div">
              {/* <input disabled value={fieldId} className="job_input_style" /> */}
              <div className="job_input_style">{fieldId}</div>
            </div>
          </>
        )}
        {printIcon
          && (
            <div onClick={handlePrintClick}>
              <PrintIcon />
            </div>
          )}
        {siteSwitch && (
          <div className="switchContainer">
            <IOSSwitch defaultChecked checked={!isChecked} onChange={handleSwitchChange} />
            <p>Show Latest Versions Only</p>
          </div>
        )}
        {downloadExcel
          && (
            <div onClick={downloadExcel}>
              <XlsxIcon />
            </div>
          )}
        {buttonName && (
        <Button
          className="button_save_and_next"
          onClick={handleButtonClick}
        >
          {buttonName}
        </Button>
        )}
      </div>
    </div>
  );
}
